import PpgExtractor from './PpgExtractor';

export default PpgExtractor;
